import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { WarningIcon } from '@icons/WarningIcon'

import { Body1, Heading6 } from '@ui/Typography'

import { Button } from '@global/button/Button'

import { PersonalDetailsTemplate } from '../PersonalDetailsTemplate'

import styles from '../PersonalDetailsPage.module.scss'

export const PersonalDetailsStepUSPage: React.FC = () => {
  const navigate = useNavigate()
  const goBack = () => {
    navigate('/sign-up/personal-details/')
  }

  return (
    <PersonalDetailsTemplate totalSteps={0} step={1} USStep goBack={goBack}>
      <USCitizenWarning onGoBack={goBack} />
    </PersonalDetailsTemplate>
  )
}

const USCitizenWarning = ({ onGoBack }: { onGoBack: () => void }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles.usWarning}>
      <div className={styles.usWarningHeader}>
        <WarningIcon color={'textDangerHighEm'} size={18} />
        <Heading6 className='pl-3' medium>
          {t('Sign up.US Citizen')}
        </Heading6>
      </div>
      <p className={styles.subtitle}>
        {t("Sign up.Unfortunately, we can't offer our services to US citizens")}
      </p>
      <Body1 isParagraph className={styles.text}>
        {t('Sign up.A US Citizen has been defined by the IRS as')}
      </Body1>
      <ul className={styles.list}>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.An individual born in the United States')}
        </li>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.An individual whose parent is a US citizen')}
        </li>
        <li className={styles.text}>
          {t(
            'Sign up.USCitizenConditions.An individual born in Puerto Rico, Guam or the US Virgin Islands'
          )}
        </li>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.A former alien who has been naturalized as a US citizen')}
        </li>
      </ul>
      <div className={styles.buttonWrapper}>
        <Button type='button' size='L' appearance='secondary' onClick={() => onGoBack()}>
          <Body1 medium>{t("Sign up.I'm Not a US Citizen")}</Body1>
        </Button>
        <Button type='button' appearance='primary' size='L' onClick={() => navigate('/login')}>
          <Body1 medium>{t("Sign up.I'm a US Citizen")}</Body1>
        </Button>
      </div>
    </div>
  )
}
